import { Button, Descriptions, Dropdown, Popconfirm, Space } from "antd";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { date2locale } from "../common/common";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function Absence() {
  const navigate = useNavigate();
  const data = useRouteLoaderData("absence");
  const { id } = useParams();

  const items = [
    { key: "employee", label: "Dipendente", children: data.employee.fullName },
    { key: "type", label: "Categoria assenza", children: data.type.name ?? data.type.id },
    { key: "date", label: "Data", children: date2locale(data.date) },
  ];

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli assenza"
        secondary={`ID: ${id}`}
        extra={
          <Space size={4}>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deleteAbsence",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => api.absence.delete(id).then(() => navigate(".."))}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={3}
        colon={false}
        items={items}
      />
    </div>
  );
}
